module.exports = __webpack_public_path__ + "img/service-icon4.de25d238.png";